import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
import php from 'highlight.js/lib/languages/php';
import xml from 'highlight.js/lib/languages/xml';

hljs.registerLanguage( 'javascript', javascript );
hljs.registerLanguage( 'js', javascript );
hljs.registerLanguage( 'php', php );
hljs.registerLanguage( 'xml', xml );
hljs.registerLanguage( 'html', xml );

function copyText( text ) {
	if ( navigator.clipboard && window.isSecureContext ) {
		return navigator.clipboard.writeText( text );
	}

	const textarea = document.createElement( 'textarea' );
	textarea.value = text;
	textarea.setAttribute( 'readonly', '' );
	textarea.style.position = 'fixed';
	textarea.style.top = '-9999px';
	document.body.appendChild( textarea );
	textarea.select();

	return new Promise( ( resolve, reject ) => {
		try {
			document.execCommand( 'copy' );
			resolve();
		} catch ( error ) {
			reject( error );
		} finally {
			textarea.remove();
		}
	} );
}

function addCopyButton( block ) {
	const pre = block.closest( 'pre' );

	if ( ! pre || pre.parentElement.classList.contains( 'code-copy' ) ) {
		return;
	}

	const wrapper = document.createElement( 'div' );
	wrapper.className = 'code-copy';

	const button = document.createElement( 'button' );
	button.className = 'code-copy__button';
	button.type = 'button';
	button.textContent = 'Copy';
	button.setAttribute( 'aria-label', 'Copy code' );

	pre.parentNode.insertBefore( wrapper, pre );
	wrapper.appendChild( pre );
	wrapper.appendChild( button );

	button.addEventListener( 'click', () => {
		copyText( block.textContent )
			.then( () => {
				button.textContent = 'Copied';
				button.classList.add( 'is-copied' );

				window.setTimeout( () => {
					button.textContent = 'Copy';
					button.classList.remove( 'is-copied' );
				}, 1800 );
			} )
			.catch( () => {
				button.textContent = 'Error';
				window.setTimeout( () => {
					button.textContent = 'Copy';
				}, 1800 );
			} );
	} );
}

export default function initCodeHighlight() {
	const codeBlocks = document.querySelectorAll(
		'.entry-content pre code, .entry-content code.language-php, .entry-content code.language-html, .entry-content code.language-js, .entry-content code.language-javascript'
	);

	codeBlocks.forEach( ( block ) => {
		hljs.highlightElement( block );
		addCopyButton( block );
	} );
}
